module.exports = __webpack_public_path__ + "img/email.c35df616.svg";